export interface ActiveI9Item {
  i9FormId: string;
  accountName: string;
  firstName: string;
  lastName: string;
  employeeName: string;
  ssn?: string;
  email?: string;
  status: string;
  statusDisplay: string;
  /** Null when no location has been assigned yet. */
  location: string | null;
  hireDate?: Date;
  signatureDate?: Date;
  nextAction: I9RecordAction;
  canArchive?: boolean;
  referenceNumber: string;
  // Remediation error count for digitized/historical records; null for live-workflow records (VTK-1740).
  errorCount?: number | null;
  /** When the I-9 case was created (VTK-1851). */
  createdAt?: Date;
  /**
   * Most recent invite/link send for this record, whichever section it belonged to (VTK-1851). This
   * list mixes live Section 1 cases with remote Section 2 ones, so the column means "when did we last
   * send this record a link" rather than naming a particular section's invite.
   */
  dateSent?: Date;
  /**
   * Why the row is on the Reverifications Due screen's Needs review tab, one per row. Null on every
   * other listing, and on a value this build does not know.
   */
  reviewReason?: ReverificationReviewReason | null;
}

export const REVERIFICATION_REVIEW_REASONS = [
  'DURATION_OF_STATUS',
  'MISSING_DOCUMENT_EXPIRY',
  'UNREADABLE_EXPIRY',
  'H1B_DECISION_PENDING',
] as const;

export type ReverificationReviewReason = (typeof REVERIFICATION_REVIEW_REASONS)[number];

export const isReverificationReviewReason = (value: unknown): value is ReverificationReviewReason =>
  (REVERIFICATION_REVIEW_REASONS as readonly unknown[]).includes(value);

export enum I9RecordAction {
  REMIND_COMPLETE_SECTION1 = 'REMIND_COMPLETE_SECTION1',
  COMPLETE_SECTION2 = 'COMPLETE_SECTION2',
  PROVIDE_SSN_TO_TRIGGER_EVERIFY = 'PROVIDE_SSN_TO_TRIGGER_EVERIFY',
  REMIND_COMPLETE_SUPPLEMENT_B = 'REMIND_COMPLETE_SUPPLEMENT_B',
  MANAGE_EVERIFY_CASE = 'MANAGE_EVERIFY_CASE',
  REVIEW_SECTION2 = 'REVIEW_SECTION2',
  PENDING_FROM_REMOTE_COMPLETER = 'PENDING_FROM_REMOTE_COMPLETER',
}